import React, { useState } from "react";
import { View, Image, Text, TouchableOpacity, StyleSheet } from "react-native";
import { Ionicons } from "@expo/vector-icons";

/**
 * Photo carousel for Google Place photos with left/right nav buttons.
 */
export default function PlacePhotoCarousel({ photoUrls, height = 200, edgeToEdge = false }) {
  const [index, setIndex] = useState(0);
  const photos = Array.isArray(photoUrls) ? photoUrls.filter(Boolean) : [];
  const radiusStyle = edgeToEdge ? styles.edgeToEdge : styles.rounded;

  if (photos.length === 0) {
    return (
      <View style={[styles.empty, radiusStyle, { height }]}>
        <Text style={styles.emptyText}>No photos</Text>
      </View>
    );
  }

  const safeIndex = index % photos.length;
  const showNav = photos.length > 1;

  const goPrev = () => {
    setIndex((current) => (current - 1 + photos.length) % photos.length);
  };

  const goNext = () => {
    setIndex((current) => (current + 1) % photos.length);
  };

  return (
    <View style={[styles.container, radiusStyle, { height }]}>
      <Image
        source={{ uri: photos[safeIndex] }}
        style={styles.image}
        resizeMode="cover"
      />

      {showNav ? (
        <>
          <TouchableOpacity
            style={[styles.navButton, styles.navLeft]}
            onPress={goPrev}
            activeOpacity={0.8}
            accessibilityRole="button"
            accessibilityLabel="Previous photo"
          >
            <Ionicons name="chevron-back" size={22} color="#fff" />
          </TouchableOpacity>

          <TouchableOpacity
            style={[styles.navButton, styles.navRight]}
            onPress={goNext}
            activeOpacity={0.8}
            accessibilityRole="button"
            accessibilityLabel="Next photo"
          >
            <Ionicons name="chevron-forward" size={22} color="#fff" />
          </TouchableOpacity>

          <View style={styles.badgeRow}>
            <View style={styles.badge}>
              <Text style={styles.badgeText}>
                {safeIndex + 1} / {photos.length}
              </Text>
            </View>
          </View>
        </>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    overflow: "hidden",
    backgroundColor: "#e8e0dc",
    position: "relative",
  },
  rounded: {
    borderRadius: 12,
  },
  edgeToEdge: {
    borderRadius: 0,
  },
  image: {
    width: "100%",
    height: "100%",
  },
  navButton: {
    position: "absolute",
    top: "50%",
    marginTop: -18,
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: "rgba(0,0,0,0.45)",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2,
  },
  navLeft: {
    left: 10,
  },
  navRight: {
    right: 10,
  },
  badgeRow: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 10,
    alignItems: "center",
    zIndex: 2,
  },
  badge: {
    backgroundColor: "rgba(0,0,0,0.55)",
    borderRadius: 8,
    paddingHorizontal: 8,
    paddingVertical: 4,
    minWidth: 56,
    alignItems: "center",
  },
  badgeText: {
    color: "#fff",
    fontSize: 12,
    fontWeight: "600",
  },
  empty: {
    width: "100%",
    backgroundColor: "#F0EAE6",
    alignItems: "center",
    justifyContent: "center",
  },
  emptyText: {
    color: "#999",
    fontSize: 14,
  },
});
